/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConnexionListFilters } from './ConnexionListFilters';
import {
    ConnexionListFiltersFromJSON,
    ConnexionListFiltersFromJSONTyped,
    ConnexionListFiltersToJSON,
    ConnexionListFiltersToJSONTyped,
} from './ConnexionListFilters';

/**
 * Commande de la liste admin des connexions (tri toujours par date décroissante).
 * @export
 * @interface GetConnexionListCommand
 */
export interface GetConnexionListCommand {
    /**
     * Utilisateur (contient, insensible à la casse) — même filtre que filters.userName
     * @type {string}
     * @memberof GetConnexionListCommand
     */
    searchString?: string;
    /**
     * 
     * @type {number}
     * @memberof GetConnexionListCommand
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof GetConnexionListCommand
     */
    pageSize: number;
    /**
     * 
     * @type {ConnexionListFilters}
     * @memberof GetConnexionListCommand
     */
    filters?: ConnexionListFilters;
}

/**
 * Check if a given object implements the GetConnexionListCommand interface.
 */
export function instanceOfGetConnexionListCommand(value: object): value is GetConnexionListCommand {
    if (!('pageNumber' in value) || value['pageNumber'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function GetConnexionListCommandFromJSON(json: any): GetConnexionListCommand {
    return GetConnexionListCommandFromJSONTyped(json, false);
}

export function GetConnexionListCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConnexionListCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'pageNumber': json['pageNumber'],
        'pageSize': json['pageSize'],
        'filters': json['filters'] == null ? undefined : ConnexionListFiltersFromJSON(json['filters']),
    };
}

export function GetConnexionListCommandToJSON(json: any): GetConnexionListCommand {
    return GetConnexionListCommandToJSONTyped(json, false);
}

export function GetConnexionListCommandToJSONTyped(value?: GetConnexionListCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'filters': ConnexionListFiltersToJSON(value['filters']),
    };
}

